
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../home/components/Footer';

const values = [
  {
    icon: 'ri-fire-line',
    title: 'The Grind',
    description: 'We celebrate those who show up every single day — no excuses, no shortcuts. The grind is a lifestyle, not a phase.'
  },
  {
    icon: 'ri-rocket-line',
    title: 'The Drive',
    description: 'Ambition fueled by purpose. We amplify the voices of those who are relentlessly driven to build something greater than themselves.'
  },
  {
    icon: 'ri-trophy-line',
    title: 'The Hustle',
    description: 'Hustle isn\'t just hard work — it\'s smart work, creative work, and consistent work. We honor every form of it.'
  },
  {
    icon: 'ri-team-line',
    title: 'Community',
    description: 'The Collective is more than a brand. It\'s a movement of everyday people doing extraordinary things together.'
  },
  {
    icon: 'ri-heart-line',
    title: 'Authenticity',
    description: 'Real stories. Real struggles. Real wins. We don\'t do fake — we do raw, honest, and unapologetically real.'
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Respect',
    description: 'Every hustle deserves respect. Whether you\'re just starting out or at the top — we see you, we honor you.'
  }
];

const community = [
  {
    name: 'Marcus T.',
    role: 'Entrepreneur',
    quote: 'The Collective gave me the community I didn\'t know I needed. Real people, real energy.',
    img: 'https://public.readdy.ai/ai/img_res/cf2b7ed42eb388d4a55e0b483acedc2e.jpg'
  },
  {
    name: 'Jasmine R.',
    role: 'Fitness Coach',
    quote: 'This brand speaks to my soul. The Everyday Hustle Collective is exactly what the culture needed.',
    img: 'https://readdy.ai/api/search-image?query=confident%20young%20Black%20woman%20fitness%20coach%20smiling%2C%20athletic%20wear%2C%20clean%20minimal%20light%20background%2C%20studio%20portrait%20photography%2C%20warm%20natural%20lighting%2C%20sharp%20focus%2C%20authentic%20expression&width=200&height=200&seq=collective-member2&orientation=squarish'
  },
  {
    name: 'Devon K.',
    role: 'Content Creator',
    quote: 'I wear the gear with pride. It\'s not just apparel — it\'s a statement about who I am.',
    img: 'https://readdy.ai/api/search-image?query=young%20Black%20male%20content%20creator%20smiling%2C%20casual%20streetwear%2C%20clean%20minimal%20light%20background%2C%20studio%20portrait%20photography%2C%20warm%20natural%20lighting%2C%20sharp%20focus%2C%20authentic%20expression&width=200&height=200&seq=collective-member3&orientation=squarish'
  }
];

const products = [
  {
    id: 1,
    name: 'Muscle Hustle Classic Tee',
    price: 34.99,
    category: 'T-Shirts',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'White', 'Red'],
    image: 'https://readdy.ai/api/search-image?query=Black%20premium%20cotton%20t-shirt%20with%20bold%20red%20and%20white%20graphic%20logo%20design%20on%20chest%2C%20flat%20lay%20product%20photography%20on%20clean%20white%20background%2C%20professional%20apparel%20photography%2C%20minimalist%20style%2C%20high%20contrast%2C%20sharp%20details&width=600&height=600&seq=store-tee-1&orientation=squarish',
    badge: 'Best Seller',
    description: 'The signature Muscle Hustle tee. Represent the grind every day.',
  },
  {
    id: 2,
    name: 'Respect My Hustle Hoodie',
    price: 64.99,
    category: 'Hoodies',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'Charcoal'],
    image: 'https://readdy.ai/api/search-image?query=Premium%20black%20heavyweight%20pullover%20hoodie%20with%20bold%20white%20and%20red%20text%20graphic%20print%20on%20front%2C%20flat%20lay%20product%20photography%20on%20clean%20white%20background%2C%20professional%20streetwear%20apparel%20photography%2C%20minimalist%20style&width=600&height=600&seq=store-hoodie-1&orientation=squarish',
    badge: 'New',
    description: 'Heavy-weight fleece hoodie. Stay warm, stay grinding.',
  },
  {
    id: 3,
    name: 'The Grind Snapback Cap',
    price: 29.99,
    category: 'Hats',
    sizes: ['One Size'],
    colors: ['Black/Red', 'All Black'],
    image: 'https://readdy.ai/api/search-image?query=Black%20snapback%20baseball%20cap%20with%20embroidered%20red%20logo%20on%20front%20panel%2C%20product%20photography%20on%20clean%20white%20background%2C%20professional%20hat%20photography%2C%20side%20angle%20view%2C%20minimalist%20style%2C%20sharp%20details&width=600&height=600&seq=store-cap-1&orientation=squarish',
    badge: '',
    description: 'Structured snapback with embroidered logo. Rep the brand.',
  },
  {
    id: 4,
    name: 'Hustle Mode Joggers',
    price: 54.99,
    category: 'Bottoms',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'Charcoal'],
    image: 'https://readdy.ai/api/search-image?query=Black%20premium%20athletic%20jogger%20pants%20with%20small%20red%20logo%20embroidery%20on%20leg%2C%20flat%20lay%20product%20photography%20on%20clean%20white%20background%2C%20professional%20sportswear%20apparel%20photography%2C%20minimalist%20style%2C%20high%20quality%20fabric%20texture&width=600&height=600&seq=store-joggers-1&orientation=squarish',
    badge: '',
    description: 'Comfortable performance joggers for the everyday hustler.',
  },
  {
    id: 5,
    name: 'Drive & Grind Long Sleeve',
    price: 44.99,
    category: 'T-Shirts',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'White'],
    image: 'https://readdy.ai/api/search-image?query=Black%20long%20sleeve%20premium%20cotton%20shirt%20with%20bold%20red%20and%20white%20graphic%20print%20on%20back%2C%20flat%20lay%20product%20photography%20on%20clean%20white%20background%2C%20professional%20apparel%20photography%2C%20minimalist%20style%2C%20high%20contrast&width=600&height=600&seq=store-longsleeve-1&orientation=squarish',
    badge: '',
    description: 'Long sleeve comfort with bold back print. The hustle never stops.',
  },
  {
    id: 6,
    name: 'Muscle Hustle Zip-Up Hoodie',
    price: 74.99,
    category: 'Hoodies',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'Red'],
    image: 'https://readdy.ai/api/search-image?query=Black%20premium%20zip-up%20hoodie%20with%20embroidered%20logo%20on%20chest%20and%20sleeve%2C%20flat%20lay%20product%20photography%20on%20clean%20white%20background%2C%20professional%20streetwear%20apparel%20photography%2C%20minimalist%20style%2C%20high%20quality%20fabric&width=600&height=600&seq=store-zip-1&orientation=squarish',
    badge: 'Limited',
    description: 'Premium zip-up with embroidered branding. Built for the grind.',
  },
  {
    id: 7,
    name: 'RMH Dad Hat',
    price: 24.99,
    category: 'Hats',
    sizes: ['One Size'],
    colors: ['Black', 'White', 'Red'],
    image: 'https://readdy.ai/api/search-image?query=Black%20unstructured%20dad%20hat%20with%20small%20embroidered%20red%20initials%20on%20front%2C%20product%20photography%20on%20clean%20white%20background%2C%20professional%20hat%20photography%2C%20front%20view%2C%20minimalist%20style%2C%20soft%20fabric&width=600&height=600&seq=store-dadhat-1&orientation=squarish',
    badge: '',
    description: 'Relaxed fit dad hat with subtle RMH embroidery.',
  },
  {
    id: 8,
    name: 'Hustle Everyday Crewneck',
    price: 59.99,
    category: 'Hoodies',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'White'],
    image: 'https://readdy.ai/api/search-image?query=Black%20premium%20crewneck%20sweatshirt%20with%20bold%20white%20and%20red%20graphic%20print%20on%20chest%2C%20flat%20lay%20product%20photography%20on%20clean%20white%20background%2C%20professional%20streetwear%20apparel%20photography%2C%20minimalist%20style%2C%20heavyweight%20fleece&width=600&height=600&seq=store-crew-1&orientation=squarish',
    badge: '',
    description: 'Heavyweight crewneck sweatshirt. Comfort meets the hustle.',
  },
];

const categories = ['All', 'T-Shirts', 'Hoodies', 'Hats', 'Bottoms'];

export default function CollectivePage() {
  const [visible, setVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedProduct, setSelectedProduct] = useState<typeof products[0] | null>(null);
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const [cartCount, setCartCount] = useState(0);
  const [addedToCart, setAddedToCart] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const filtered = selectedCategory === 'All'
    ? products
    : products.filter(p => p.category === selectedCategory);

  const handleAddToCart = () => {
    if (!selectedSize || !selectedColor) return;
    setCartCount(c => c + 1);
    setAddedToCart(true);
    setTimeout(() => setAddedToCart(false), 2000);
  };

  const openProduct = (product: typeof products[0]) => {
    setSelectedProduct(product);
    setSelectedSize('');
    setSelectedColor('');
  };

  return (
    <div className="min-h-screen bg-black">
      <Navigation />

      {/* Hero */}
      <section
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url('https://readdy.ai/api/search-image?query=urban%20street%20culture%20collective%20community%20gathering%2C%20stylish%20diverse%20group%20of%20people%20in%20modern%20streetwear%20apparel%2C%20bold%20red%20and%20black%20color%20palette%2C%20dramatic%20cinematic%20lighting%20with%20deep%20shadows%20and%20crimson%20accents%2C%20gritty%20yet%20aspirational%20atmosphere%2C%20high%20contrast%20editorial%20photography%2C%20abstract%20urban%20textures%20and%20patterns%20in%20background&width=1920&height=1080&seq=collective-hero-bg&orientation=landscape')`
        }}
      >
        <div className={`w-full container mx-auto px-4 md:px-6 lg:px-8 text-center transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <img
            src="https://static.readdy.ai/image/86406a665a28ba21ddd5afd6a9d3db96/c77a620a326ff3f829cc64c0334263cd.png"
            alt="The Everyday Hustle Collective Logo"
            className="w-24 h-24 md:w-32 md:h-32 object-contain invert mx-auto mb-6"
          />
          <p className="text-red-500 font-bold tracking-widest text-sm md:text-base uppercase mb-3" style={{ fontFamily: '"Teko", sans-serif' }}>
            Welcome to
          </p>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold leading-none tracking-wider mb-6" style={{ fontFamily: '"Teko", sans-serif' }}>
            <span className="text-red-500">THE</span>{' '}
            <span className="text-white">EVERYDAY HUSTLE</span>
            <br />
            <span className="text-red-500">COLLECTIVE</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto mb-10 leading-relaxed">
            A movement built for those who grind in silence, rise with purpose, and wear their hustle with pride.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#shop"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-bag-line mr-2"></i>Shop the Collection
            </a>
            <a
              href="#mission"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-black px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Our Mission
            </a>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section id="mission" className="py-20 md:py-28 bg-black">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-red-500 font-bold tracking-widest text-sm uppercase mb-4" style={{ fontFamily: '"Teko", sans-serif' }}>Our Mission</p>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight" style={{ fontFamily: '"Teko", sans-serif' }}>
                MORE THAN A BRAND.<br />
                <span className="text-red-500">A MOVEMENT.</span>
              </h2>
              <p className="text-gray-300 text-lg md:text-xl leading-relaxed mb-6">
                The Everyday Hustle Collective was born from the belief that every person grinding toward their goals deserves to be seen, heard, and celebrated. We exist to amplify the stories of everyday hustlers — the ones who don't wait for permission to build their dreams.
              </p>
              <p className="text-gray-300 text-lg md:text-xl leading-relaxed mb-8">
                From the podcast to the apparel, everything we create is a love letter to the culture of hard work, resilience, and community. When you rep the Collective, you're not just wearing a brand — you're declaring who you are.
              </p>
              <div className="flex flex-wrap gap-2">
                {['#TheGrind', '#TheDrive', '#TheHustle', '#RespectMyHustle', '#EverydayHustle'].map(tag => (
                  <span key={tag} className="bg-red-600/20 text-red-400 px-3 py-1 rounded-full text-sm font-semibold">{tag}</span>
                ))}
              </div>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=bold%20streetwear%20apparel%20brand%20lifestyle%20photography%2C%20person%20wearing%20black%20hoodie%20with%20red%20logo%20in%20urban%20setting%2C%20dramatic%20side%20lighting%2C%20gritty%20concrete%20background%20with%20red%20accent%20lighting%2C%20high%20contrast%20editorial%20fashion%20photography%2C%20authentic%20street%20culture%20aesthetic%2C%20powerful%20confident%20pose&width=600&height=700&seq=collective-mission-img&orientation=portrait"
                alt="The Everyday Hustle Collective lifestyle"
                className="rounded-2xl shadow-2xl object-cover object-top w-full h-[500px] md:h-[600px]"
              />
              <div className="absolute -bottom-6 -left-6 bg-red-600 rounded-2xl p-6 shadow-2xl max-w-xs">
                <p className="text-white font-bold text-lg leading-snug" style={{ fontFamily: '"Teko", sans-serif' }}>
                  "WHERE THE EVERYDAY HUSTLE IS RESPECTED"
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 md:py-28 bg-gray-950">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="text-center mb-16">
            <p className="text-red-500 font-bold tracking-widest text-sm uppercase mb-4" style={{ fontFamily: '"Teko", sans-serif' }}>What We Stand For</p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white" style={{ fontFamily: '"Teko", sans-serif' }}>
              THE COLLECTIVE <span className="text-red-500">VALUES</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {values.map((val, i) => (
              <div
                key={i}
                className="bg-gray-900 border border-gray-800 hover:border-red-600/50 rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-red-600/10 group-hover:bg-red-600/20 rounded-xl mb-5 transition-colors">
                  <i className={`${val.icon} text-red-500 text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: '"Teko", sans-serif' }}>{val.title}</h3>
                <p className="text-gray-400 text-base leading-relaxed">{val.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Community Voices */}
      <section className="py-20 md:py-28 bg-black">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="text-center mb-16">
            <p className="text-red-500 font-bold tracking-widest text-sm uppercase mb-4" style={{ fontFamily: '"Teko", sans-serif' }}>The People</p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white" style={{ fontFamily: '"Teko", sans-serif' }}>
              VOICES OF THE <span className="text-red-500">COLLECTIVE</span>
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {community.map((member, i) => (
              <div key={i} className="bg-gray-900 border border-gray-800 rounded-2xl p-8 flex flex-col items-center text-center hover:border-red-600/40 transition-all duration-300">
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-20 h-20 rounded-full object-cover object-top mb-5 border-2 border-red-600"
                />
                <p className="text-gray-300 text-base leading-relaxed mb-5 italic">"{member.quote}"</p>
                <p className="text-white font-bold text-lg">{member.name}</p>
                <p className="text-red-500 text-sm font-semibold">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SHOP SECTION ── */}
      <section id="shop" className="bg-black text-white">
        {/* Shop Banner */}
        <div
          className="relative h-64 md:h-80 flex items-center justify-center bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65)), url('https://readdy.ai/api/search-image?query=Stylish%20streetwear%20apparel%20collection%20flat%20lay%20with%20black%20and%20red%20clothing%20items%2C%20premium%20fabric%20textures%2C%20modern%20urban%20fashion%20photography%2C%20dark%20moody%20background%20with%20dramatic%20lighting%2C%20high%20contrast%20professional%20product%20photography&width=1920&height=600&seq=store-hero-banner&orientation=landscape')`
          }}
        >
          <div className="text-center z-10 px-4">
            <p className="text-red-500 font-semibold text-sm md:text-base tracking-widest uppercase mb-2">Official Merch</p>
            <h2 className="text-4xl md:text-6xl font-bold tracking-wider text-white" style={{ fontFamily: '"Teko", sans-serif' }}>
              SHOP THE <span className="text-red-500">COLLECTION</span>
            </h2>
            <p className="text-gray-300 mt-2 text-base md:text-lg">Wear the hustle. Rep the brand.</p>
          </div>
        </div>

        {/* Cart indicator */}
        {cartCount > 0 && (
          <div className="sticky top-16 md:top-20 z-40 bg-red-600 text-white text-center py-2 text-sm font-semibold">
            <i className="ri-shopping-bag-line mr-2"></i>
            {cartCount} item{cartCount > 1 ? 's' : ''} in your bag — Connect Shopify to enable checkout
          </div>
        )}

        <div className="container mx-auto px-4 md:px-6 lg:px-8 py-10 md:py-14">
          {/* Category Filter */}
          <div className="flex flex-wrap gap-2 mb-8 md:mb-10 justify-center">
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  selectedCategory === cat
                    ? 'bg-red-600 text-white'
                    : 'bg-white/10 text-gray-300 hover:bg-white/20 hover:text-white'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Product Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
            {filtered.map(product => (
              <div
                key={product.id}
                onClick={() => openProduct(product)}
                className="group bg-gray-900 rounded-xl overflow-hidden border border-white/5 hover:border-red-600/40 transition-all duration-300 cursor-pointer hover:-translate-y-1"
              >
                <div className="relative w-full h-48 md:h-56 lg:h-64 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  {product.badge && (
                    <span className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-full">
                      {product.badge}
                    </span>
                  )}
                </div>
                <div className="p-3 md:p-4">
                  <p className="text-gray-500 text-xs mb-1">{product.category}</p>
                  <h3 className="text-white font-semibold text-sm md:text-base leading-tight mb-2">{product.name}</h3>
                  <div className="flex items-center justify-between">
                    <span className="text-red-400 font-bold text-base md:text-lg">${product.price.toFixed(2)}</span>
                    <div className="w-7 h-7 flex items-center justify-center bg-red-600/20 hover:bg-red-600 rounded-full transition-colors">
                      <i className="ri-add-line text-red-400 group-hover:text-white text-sm"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Shopify CTA */}
          <div className="mt-14 md:mt-20 bg-gradient-to-r from-red-900/30 to-black border border-red-600/20 rounded-2xl p-8 md:p-12 text-center">
            <div className="w-14 h-14 flex items-center justify-center bg-red-600/20 rounded-full mx-auto mb-4">
              <i className="ri-store-2-line text-red-400 text-2xl"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold mb-3" style={{ fontFamily: '"Teko", sans-serif' }}>
              READY TO SELL YOUR MERCH?
            </h2>
            <p className="text-gray-400 text-base md:text-lg max-w-xl mx-auto mb-6">
              Connect your Shopify store to enable real checkout, inventory management, and order tracking for all your apparel.
            </p>
            <div className="flex flex-wrap gap-4 justify-center text-sm text-gray-400">
              <span className="flex items-center gap-2"><i className="ri-check-line text-red-500"></i> Real-time inventory</span>
              <span className="flex items-center gap-2"><i className="ri-check-line text-red-500"></i> Secure checkout</span>
              <span className="flex items-center gap-2"><i className="ri-check-line text-red-500"></i> Order tracking</span>
              <span className="flex items-center gap-2"><i className="ri-check-line text-red-500"></i> Multiple variants</span>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Product Modal */}
      {selectedProduct && (
        <div
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedProduct(null)}
        >
          <div
            className="bg-gray-900 rounded-2xl max-w-2xl w-full overflow-hidden border border-white/10 max-h-[90vh] overflow-y-auto"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-1/2 h-64 md:h-auto">
                <img
                  src={selectedProduct.image}
                  alt={selectedProduct.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6 md:p-8 flex-1">
                <div className="flex items-start justify-between mb-2">
                  <p className="text-gray-500 text-xs uppercase tracking-widest">{selectedProduct.category}</p>
                  <button
                    onClick={() => setSelectedProduct(null)}
                    className="w-7 h-7 flex items-center justify-center text-gray-400 hover:text-white cursor-pointer"
                  >
                    <i className="ri-close-line text-lg"></i>
                  </button>
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-white mb-1">{selectedProduct.name}</h2>
                <p className="text-red-400 font-bold text-xl mb-4">${selectedProduct.price.toFixed(2)}</p>
                <p className="text-gray-400 text-sm mb-5">{selectedProduct.description}</p>

                {/* Color */}
                <div className="mb-4">
                  <p className="text-gray-300 text-sm font-semibold mb-2">Color</p>
                  <div className="flex flex-wrap gap-2">
                    {selectedProduct.colors.map(color => (
                      <button
                        key={color}
                        onClick={() => setSelectedColor(color)}
                        className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-all cursor-pointer whitespace-nowrap ${
                          selectedColor === color
                            ? 'border-red-500 bg-red-600/20 text-red-400'
                            : 'border-white/20 text-gray-400 hover:border-white/40'
                        }`}
                      >
                        {color}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Size */}
                <div className="mb-6">
                  <p className="text-gray-300 text-sm font-semibold mb-2">Size</p>
                  <div className="flex flex-wrap gap-2">
                    {selectedProduct.sizes.map(size => (
                      <button
                        key={size}
                        onClick={() => setSelectedSize(size)}
                        className={`w-10 h-10 flex items-center justify-center rounded-lg text-xs font-bold border transition-all cursor-pointer ${
                          selectedSize === size
                            ? 'border-red-500 bg-red-600/20 text-red-400'
                            : 'border-white/20 text-gray-400 hover:border-white/40'
                        }`}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>

                <button
                  onClick={handleAddToCart}
                  disabled={!selectedSize || !selectedColor}
                  className={`w-full py-3 rounded-full font-bold text-sm transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    addedToCart
                      ? 'bg-green-600 text-white'
                      : selectedSize && selectedColor
                      ? 'bg-red-600 hover:bg-red-700 text-white'
                      : 'bg-white/10 text-gray-500 cursor-not-allowed'
                  }`}
                >
                  {addedToCart ? (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-check-line"></i> Added to Bag!
                    </span>
                  ) : (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-shopping-bag-line"></i>
                      {selectedSize && selectedColor ? 'Add to Bag' : 'Select Size & Color'}
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
